import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next"; // Import useTranslation
import cn from "classnames";
import styles from "./page.module.scss";
import ArrowBackIcon from "../../shared/icons/ArrowBackIcon";
import SecurityIcon from "../../shared/icons/SecurityIcon";
import { useParams } from "react-router-dom";
import { User } from "../../../services";
import { toast } from "react-toastify";
import { LanguageDropdown } from "../../LanguageSelector/LanguageSelector";
import RegistrationForm from "../components-cn/RegistrationForm";
import RegistrationSurveyUser from "../components-cn/RegistrationSurveyUser";

let appendFP = false;
const RegistrationPageCN = () => {
  const { t } = useTranslation();
  const rootEl = useRef(null);
  const [step, setStep] = useState(localStorage.getItem("step") ? Number(localStorage.getItem("step")) : 1); // => 1
  const [data, setData] = useState({});
  const { code } = useParams();

  const urlParams = new URLSearchParams(window.location.search);
  const codeParam = urlParams.get("code");

  useEffect(() => {
    if (codeParam) {
      User.getCodeInfo(codeParam)
        .then((response) => {
          if (response.status == 200) {
            toast.success(t("registrationPageNew.toast.linkActivated"));
            console.log("[response]", response.data);
            setData(response.data);
          } else toast.error(t("registrationPageNew.toast.linkInactive"));
        })
        .catch((err) => {
          console.log(err);
          toast.error(t("registrationPageNew.toast.linkInactive"));
        });
    }
  }, [codeParam]);

  // Meta Pixel Code
  useEffect(() => {
    if (rootEl && !appendFP) {
      const scriptBody = `
        !function(f,b,e,v,n,t,s) { if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window,document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1048831292922421');
        fbq('track', 'PageView');
      `;
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.innerHTML = scriptBody;
      rootEl.current.appendChild(s);

      const noS = document.createElement("noscript");
      const img = document.createElement("img");
      img.src = "https://www.facebook.com/tr?id=1048831292922421&ev=PageView&noscript=1";
      img.width = 1;
      img.height = 1;
      img.style.display = "none";
      noS.appendChild(img);
      rootEl.current.appendChild(noS);
      appendFP = true;
    }
  }, [rootEl]);
  // End Meta Pixel Code

  const renderContent = () => {
    switch (step) {
      case 1:
        return <RegistrationForm updateStep={(step) => setStep(step)} setData={(newData) => { setData({ ...data, ...newData }) }} data={data} />
      case 2:
        return <RegistrationSurveyUser updateStep={(step) => setStep(step)} setData={(newData) => { setData({ ...data, ...newData }) }} data={data} />
    }
  }

  const stepDetails = [
    {
      title: t("registrationPageNew.steps.step1.title"),
      text: t("registrationPageNew.steps.step1.text"),
    },
    {
      title: t("registrationPageNew.steps.step4.title"),
      text: t("registrationPageNew.steps.step3.text"),
    },
  ];

  const previousStep = () => {
    setStep((prevStep) => Math.max(prevStep - 1, 1));
  };

  return (
    <div ref={rootEl} className={styles.containerReg}>
      {/* Form Content */}
      <div className={cn(styles.containerReg_wallpaper)}>
        <div className={styles.card}>
          {/* Header */}
          <div className={styles.card_topbar}>
            <div className={styles.card_logo}>
              <img src="/icons/ic_biny_dark.svg" alt="logo" />
            </div>
            <LanguageDropdown />
          </div>

          {/* Main */}
          <div className={styles.card_content}>
            <div className={styles.card_head}>
              <button
                type="button"
                className={styles.card_back}
                onClick={previousStep}
                style={{ display: step > 1 ? "block" : "none" }}
              >
                <ArrowBackIcon />
              </button>
              <div className={styles.card_title}>
                <span>{stepDetails[step - 1].title}</span>
              </div>
              <div className={styles.card_head_text} style={{ display: step > 1 ? "block" : "none" }}>
                <span>{stepDetails[step - 1].text}</span>
              </div>
            </div>

            {renderContent()}
          </div>
          {step > 1 && (
            <div className={styles.card_footer}>
              <SecurityIcon />
              <span>{t("registrationPageNew.footer.securityNotice")}</span>
            </div>
          )}
        </div>

        <div className={styles.right}>
          <div className={styles.banner}>
            <div className={styles.banner_dec}>
              <div className={styles.banner_title}>{t("registrationPageNew.banner.title")}</div>
              <div className={styles.banner_text}>{t("registrationPageNew.banner.text")}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPageCN;
